function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from 'react';
import { CardIcon } from './elements';
export const PAYMENT_BADGE_TYPES = ['generic', 'visa', 'mastercard', 'discover', 'american-express', 'diners-club', 'google-pay', 'paypal', 'apple-pay'];
export const PaymentBadge = /*#__PURE__*/React.forwardRef(({
  badgeType = 'generic',
  altText,
  ...props
}, fRef) => /*#__PURE__*/React.createElement(CardIcon, _extends({
  "data-aui": "payment-badge",
  ref: fRef,
  src: `https://assets.asurion-ui.my.asurion53.com/images/badges/payment/${badgeType}.svg`,
  alt: altText === 'placeholder' ? 'Payment Badge Icon' : `${altText} Card`
}, props)));